"use strict";
/**
 * Removes every white spaces
 * @param {string} string
 * @returns {string} the string without the values
 */
Object.defineProperty(exports, "__esModule", { value: true });
function removeWhiteSpaces(string) {
    if (string.length > 0) {
        return string.replace(/\s+/g, "");
    }
    return string;
}
exports.default = removeWhiteSpaces;
